import React from "react";
import { MdAdd, MdSend } from "react-icons/md";
import { Spinner } from "react-rainbow-components";
import ModalMenuChat from "../ModalMenuChat";
import {
  ContainerInput,
  InputBar,
  Input,
  ContainerAddFile,
} from "./index.style";
import useChatInput from "./useChatInput";

const ChatInput = (props: { uid: string }) => {
  const {
    handleSendMessage,
    message,
    setMessage,
    isSendingMessage,
    setIsOpenMenu,
    user,
    isOpenMenu,
  } = useChatInput(props);
  return (
    <ContainerInput
      onSubmit={(e) => {
        e.preventDefault();
        handleSendMessage();
      }}
    >
      <InputBar>
        <Input
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="ข้อความ"
        />
      </InputBar>
      <ContainerAddFile onClick={handleSendMessage}>
        {isSendingMessage ? <Spinner size="small" /> : <MdSend size={24} />}
      </ContainerAddFile>
      <ContainerAddFile onClick={() => setIsOpenMenu(true)}>
        <MdAdd size={24} />
      </ContainerAddFile>
      {user.userData?.uid && (
        <ModalMenuChat
          uid={props.uid}
          doctorId={user.userData?.uid}
          isOpen={isOpenMenu}
          onRequestClose={() => setIsOpenMenu(false)}
        />
      )}
    </ContainerInput>
  );
};

export default ChatInput;
